import Vue from 'vue';

Vue.component('stock-check-index', () =>
    import(/* webpackChunkName: 'stock-check-index' */ './stock-check-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/franchise-inventory/stock-check/index.js